import { TableStatusChip } from '@trackman/web-shared-components';
import { TranslationStatus } from 'types/admin/modulesV2';

type StatusOrUnknown = TranslationStatus | undefined;

type StatusChipIntent = 'success' | 'error' | 'warning' | 'info' | 'grey';

const labels: Record<TranslationStatus, string> = {
  NotRequested: 'Not translated',
  InTranslation: 'In progress',
  Stale: 'Translation stale',
  Translated: 'Translated',
};

const intents: Record<TranslationStatus, StatusChipIntent> = {
  NotRequested: 'grey',
  InTranslation: 'info',
  Stale: 'warning',
  Translated: 'success',
};

type Props = {
  status: StatusOrUnknown;
};

export const TranslationStatusChip = ({ status }: Props) => (
  <TableStatusChip
    label={status ? labels[status] : 'Translation status unknown'}
    intent={status ? intents[status] : 'grey'}
  />
);
